<template>
  <NuxtLink :to="'/'+slug" class="image-and-title g-8 aspect-1 full-width circle flex-center the-same-gap"
            style="background: linear-gradient(180deg, #f8f8f8, #fff 49.48%, #f8f8f8); display: flex; font-size: 13px;">
    <img :src="image" :alt="title || ''" class="image aspect-1">
    <Heading tag="h2" class="title no-flex flex-center">{{ title }}</Heading>
  </NuxtLink>
</template>

<script>
import Heading from "~/components/atoms/Heading.vue";

export default {
  components: {Heading},
  props: ['image', 'title', 'entity', 'slug']
}
</script>

<style scoped lang="scss">
img {
  max-width: 53%;
  width: 49%;
  transition: transform 1.2s ease;

  @include mobile {
    max-width: 43%;
  }
}

.title {
  @include mobile {
    font-size: 9px;
  }
}

.image-and-title {
  &:hover {
    img {
      transform: scale(1.1);
    }
  }
}

h2 {
  font-size: 13px;
  font-weight: 400;
}
</style>
